export default "__VITE_ASSET__b26702c7__"